import type { RouteRecordRaw, Router } from 'vue-router'
import DefaultTemplate from '@/layouts/templates/default.vue'
import PlainTemplate from '@/layouts/templates/plain.vue'
import { guestRoutes } from '@/router/routes/guestRoutes'
import { authRoutes } from '@/router/routes/authRoutes'

/**
 * Two sibling nested groups at `/`:
 *  - GuestGroup — `meta.guest: true`, mounts the `plain` template
 *    (centered shell for login / password reset / error pages).
 *  - AuthGroup — `meta.auth: true`, mounts the `default` template
 *    (sidebar + header + footer + drawer column).
 *
 * Layout templates are wired DIRECTLY here — previously a
 * `DefaultLayout.vue` indirection picked between them via
 * `<component :is="layoutComponent">`. That layer earned nothing
 * (there are exactly two layouts, statically chosen by route group)
 * and added an async-component boundary that contributed to a
 * Teleport timing race we hit on the drawer. Removed.
 *
 * Catch-all at the end → ErrorPage with `error=NOT_FOUND`.
 */
export const routeList = (router: Router): RouteRecordRaw[] => [
  {
    path: '/',
    name: 'Root',
    children: [
      {
        path: '',
        component: PlainTemplate,
        meta: { guest: true, template: 'plain' },
        children: guestRoutes(router),
      },
      {
        path: '',
        component: DefaultTemplate,
        meta: { auth: true, template: 'default' },
        children: authRoutes(router),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: { name: 'ErrorPage', query: { error: 'NOT_FOUND' } },
  },
]
